import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { CREATE_CUSTOM_ADDRESS, GET_ADDRESSES_LIST } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { AxiosResponse } from "axios";
import { ICreateCustomAddress } from "@/types/apiResponse.types";
import { toast } from "react-toastify";
import { TCreateCustomAddress } from "@/types/apiParam.types";

export const useCreateCustomAddressRequest = (): UseMutateAsyncFunction<
  AxiosResponse<ICreateCustomAddress>,
  Error,
  TCreateCustomAddress,
  unknown
> => {
  const queryClient = useQueryClient();
  const { mutateAsync: createCustomAddress } = useMutation({
    mutationFn: (data: TCreateCustomAddress) =>
      apiRequest(CREATE_CUSTOM_ADDRESS, "post", data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ADDRESSES_LIST],
        exact: false,
      });
      toast.success("Custom address created successfully ", {
        position: "top-center",
      });
    },
    onError: (error) => {
      const errorMessage = () => {
        const fields = [
          "cardId",
          "pinFl",
          "addressLabel",
          "regionId",
          "cityId",
          "streetName",
          "lastName",
          "firstName",
          "dateOfBirth",
          "phone",
        ];

        for (const field of fields) {
          //@ts-ignore
          if (error?.response?.data?.error?.error_fields?.[0]?.[field]) {
            //@ts-ignore
            return `${field}: ${error.response.data.error.error_fields[0][field]}`;
          }
        }
        return null;
      };
      toast.error(
        errorMessage() ||
          //@ts-ignore
          error?.response?.data?.error?.message ||
          "Error occured",
        {
          position: "top-center",
        },
      );
    },
  });
  return createCustomAddress;
};
